import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import isDesktop from '../../shared/utils/isDesktop';

const useStyles = makeStyles(() => ({
  deliveryIcon: {
    marginRight: '4px',
  },
}));

const PlatformIcon = ({ platform, alt, title }) => {
  const iconSrc = `/img/delivery-Icons/${platform}-icon.svg`;
  const iconWidth = isDesktop ? '24px' : '40px';
  const iconHeight = isDesktop ? '24px' : '40px';
  const classes = useStyles();

  return (
    <img
      width={iconWidth}
      height={iconHeight}
      src={iconSrc}
      alt={alt || platform}
      title={title || platform}
      className={classes.deliveryIcon}
    />
  );
};

export default PlatformIcon;
